<template>
  <router-link class="index-block" :to="`/${data.url}`" :js-stamp="data.url" :data-conference="data.url">
    <div class="i-block__stamp">
      <div class="i-block__lotti-cont lotti--init" v-show="!isReady"></div>
      <div class="i-block__lotti-cont lotti--loop" v-show="isReady"></div>
    </div>
    <h1 class="i-block__title" js-anim="title">{{ data.title }}</h1>
    <p class="i-block__subtitle" js-anim="title">{{ data.subTitle }}</p>
    <div class="i-block__caption">
      <div class="c-button">
        <span>{{ data.caption }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'IndexBlock',

  props: {
    data: {
      type: Object,
      required: true,
    },

    isReady: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.index-block {
  position: relative;
  flex: 1 0 auto;
  width: 100%;
  height: auto;
  background-color: $color-light;
  padding: 60px 0;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column nowrap;

  @include mq(ipadP) {
    flex-basis: 50%;
  }

  &:first-child {
    @include mq($until: ipadL) {
      padding: 80px 0 60px;
    }
  }

  h1,
  p {
    color: white;
    // transition: all 0.5s $global-ease;
  }

  // &:hover {
  //   h1,
  //   p {
  //     color: white;
  //   }
  // }

  @include mq(ipadL) {
    flex: 0 0 50%;
    width: 50%;
    height: 100%;
  }

  &:first-child {
    // background-color: #f5f5f5;
    // color: $color-text;
    // transition: all 0.5s $global-ease;

    // &:hover {
    //   color: $color-light;
    background-color: $color-pink;
    // }
  }

  &:nth-child(2) {
    // background-color: #f1f1f1;
    // color: $color-text;
    // transition: all 0.5s $global-ease;

    // &:hover {
    //   color: $color-light;
    background-color: $color-blue;
    // }
  }

  .i-block__stamp {
    position: relative;
  }

  .i-block__lotti-cont {
    // position: absolute;
    // top: 0;
    // left: 0;
    // width: 100%;
    // height: 100%;
  }

  .i-block__lotti-cont {
    position: relative;
    width: 40vw;
    height: 40vh;
    max-width: 160px;
    max-height: 173px;

    @include mq(ipadL) {
      max-width: 230px;
      max-height: 250px;
    }
  }

  .i-block__caption {
    display: inline-block;
    position: relative;
    margin-top: 25px;
    opacity: 0;

    font-size: 1rem;

    @include mq(ipadP) {
      margin-top: 45px;
    }

    .c-button {
      display: inline-block;
      position: relative;

      @at-root .pointerevents:not(.touchevents) & {
        opacity: 0;
        transform: translateY(20px);
        transition: all 0.5s $global-ease;
      }
    }
  }

  @at-root .pointerevents:not(.touchevents) &:hover,
  .no-pointerevents.no-touchevents &:hover {
    .i-block__caption .c-button {
      opacity: 1;
      transform: translateY(0px);
    }
  }

  h1 {
    display: inline-block;
    font-size: font-size(m);
    letter-spacing: 5px;
    margin: 10px 0 10px;

    @include mq(mobile) {
      font-size: font-size(ml);
    }

    @include mq(mobileX) {
      font-size: font-size(l);
    }

    @include mq(ipadL) {
      margin: 30px 0 10px;
    }
  }

  p {
    display: inline-block;
  }
}

.c-button {
  display: inline-block;
  position: relative;
  padding: 0;

  background-color: transparent;
  border: none;
  outline: transparent;

  cursor: pointer;

  & span {
    position: relative;
    display: inline-block;
    padding: 12px 30px;
    font-weight: 700;
    color: $color-light;

    z-index: 5;

    transition: transform 0.4s $global-ease;
  }

  & span,
  &::before,
  &::after {
    display: inline-block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &::before,
  &::after {
    content: '';

    position: absolute;

    border: 1px solid $color-text;
    border-radius: 18px;

    transition: transform 0.4s $global-ease;

    .index-block[data-conference="amsterdam"] & {
      background-color: #FB8D83;
    }

    .index-block[data-conference="san-francisco"] & {
      background-color: #196ABD;
    }
  }

  &::before {
    transform: translateX(3px) translateY(3px);

    .index-block[data-conference="amsterdam"] & {
      background-color: #C38B87;
    }

    .index-block[data-conference="san-francisco"] & {
      background-color: #376DA5;
    }
  }

  @at-root .pointerevents:not(.touchevents) &:hover::after,
  .no-pointerevents.no-touchevents &:hover::after {
    transform: translateX(3px) translateY(3px);
  }

  @at-root .pointerevents:not(.touchevents) &:hover span,
  .no-pointerevents.no-touchevents &:hover span {
    transform: translateX(3px) translateY(3px);
  }
}
</style>
